<!-- <div style="display: flex; justify-content: center;">
  <ngx-doc-viewer
  [url]="resource.url"
  viewer="url" 
  
></ngx-doc-viewer>
</div> -->
<div style="display: flex; justify-content: center;">
  <div style="width:90%;height:60vh; ">
    <ngx-extended-pdf-viewer
    [src]="resource.url"
    [useBrowserLocale]="true" 
    [textLayer]="true"
    [showToolbar]="true"
    [showSidebarButton]="true"
    [showFindButton]="true"
    [showPagingButtons]="true"
    [showDrawEditor]="false"
    [showTextEditor]="false"
    [showZoomButtons]="true"
    [showPresentationModeButton]="true"
    [showOpenFileButton]="false"
    [showPrintButton]="false"
    [showDownloadButton]="false"
    [showSecondaryToolbarButton]="false"
    [showRotateButton]="true"
    [showHandToolButton]="false"
    [showScrollingButton]="true"
    [showSpreadButton]="false"
    [showPropertiesButton]="false">
    >
  </ngx-extended-pdf-viewer>
  </div>
</div>






<!-- <div style="display: flex; justify-content: center;">
  <pdf-viewer src="https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf" [original-size]="false" style="height: 70vh; width: 90%"></pdf-viewer>
</div> -->
